<template>
  <div>
    <div class="content">
      <base-block class="mb-0">
        <div class="text-center mt-0">
          <h3 class="mt-2">{{ this.$route.params.name }}</h3>
          <p class="mt-2">{{ test.description ? test.description : "" }}</p>
        </div>
      </base-block>
      <br />
      <base-block rounded title="Test Details">
        <div class="bg-white rounded p-3 pr-3 pl-3 mb-3">
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Question Selection Type</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{ test.test_type == 'random'? 'Random' : test.test_type == 'default' ? 'Default' : '-'  }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Duration</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{ test.duration ? test.duration : "-" }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Total Question Count</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{ test.no_of_questions ? test.no_of_questions : "-" }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Attempts</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{ test.attempts ? test.attempts : "-" }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Negative Marks</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{ test.negative_mark ? test.negative_mark : "-" }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Each Question Mark</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{
                test.each_question_mark ? test.each_question_mark : "-"
              }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Start Date & Time</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{ test.start_date_time ? test.start_date_time : "-" }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">End Date & Time</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{ test.end_date_time ? test.end_date_time : "-" }}</b>
            </p>
          </div>
           <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Coding</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{ test.has_coding == 1 ? "Yes" : "No" }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Result Status</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{
                test.result_status == 1
                  ? "Result"
                  : test.result_status == 2
                  ? "Result & Solution"
                  : test.result_status == 3
                  ? "No Result"
                  : "-"
              }}</b>
            </p>
          </div>
        </div>
        <div class="text-center">
          <router-link
            :to="{
              name: 'View Test Questions Mock Test',
              params: { id: this.$route.params.id },
            }"
          >
            <b-button variant="success"> Next </b-button>
          </router-link>
        </div>
        <br />
      </base-block>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      test: {},
    };
  },
  mounted() {
    this.getTests();
  },
  methods: {
    async getTests() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/mock-test/detail/${this.$route.params.id} `,
          {
            headers: { Authorization: `Bearer ${this.$store.getters.token}` },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.test = response.data.test_detail;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>